import React from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getDetail } from "../../redux/actions";
import style from "./detail.module.css";
import Loading from "../../components/Loading/Loading";

const Detail = () => {
  const dispatch = useDispatch();

  let { id } = useParams();
  //Se puede acceder al id de cada elemento usando props.match.params.id
  useEffect(() => {
    dispatch(getDetail(id));
  }, [dispatch, id]);

  const loading = useSelector((state) => state.detailsLoading);
  console.log(loading);

  const myCountry = useSelector((state) => state.detail);
  console.log(myCountry);

  return (
    <div>
      {myCountry.hasOwnProperty("name") && !loading ? (
        <div className={style.containD}>
          <div className={style.detailsI}>
            <h1>{myCountry.name}</h1>
            <img className={style.image}src={myCountry.image} alt="flag country" width={"470px"} />
            <h3>capital</h3>
            <h1>{myCountry.capital}</h1>
          </div>
          <div className={style.details}>
            <p>· continet: {myCountry.continents}</p>
            <p>· subregion: {myCountry.subregion}</p>
            <p>· code: {myCountry.id} </p>
            <p>· area: {myCountry.area} km2</p>
            <p>· population: {myCountry.population}</p>
            <p>. activities: </p>

            {myCountry.activities.length ? (
              myCountry.activities.map((c) => (
                <div key={c.name} className={style.ac}>
                  <p>· Activity name: {c.name}</p>
                  <p>Difficulty: {c.difficulty}</p>
                  <p>Duration: {c.duration}</p>
                  <p>Season: {c.season}</p>
                </div>
              ))
            ) : (
              <div>
                {" "}
                <p>· Activity: not found</p>
              </div>
            )}
          </div>

          
        </div>
      ) : (
        <Loading />
      )}
      <div>
            <Link to="/home" >
              <button className={style.buttonDetail}>Back</button>
            </Link>
          </div>
    </div>
  );
};
export default Detail;
